export function getGclid() {
  return $.cookie("gclid") || "";
}

export function sendHubspotForm(lastName, firstName, email, company, jobTitle, country, accountId, source, sourceOther) {
  var formElement = document.querySelector('.hs_signup form');

  if (formElement){
    formElement.elements["email"].value = email;
    formElement.elements["firstname"].value = firstName;
    formElement.elements["lastname"].value = lastName;
    formElement.elements["company"].value = company;
    formElement.elements["jobtitle"].value = jobTitle;
    formElement.elements["country"].value = country;
    formElement.elements["accountid"].value = accountId
    formElement.elements["prospect_source"].value = source || "";
    formElement.elements["prospect_source___other"].value = sourceOther || "";
    formElement.elements["gclid"].value = getGclid();
    formElement.submit()
  }
}
